import { REQUEST_STATUSES } from "@/constants/index.js";

import * as types from "./types.js";
import { ExperienceMediaItemService } from "../../../services";

export const getExperienceMediaItems = (propertyId, experienceId, query) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_EXPERIENCE_MEDIA_ITEMS_REQUEST_STATUS,
      payload: { status: REQUEST_STATUSES.LOADING },
    });

    const { resp, status, err } = await ExperienceMediaItemService.getExperienceMediaItems(
      propertyId,
      experienceId,
      query,
    );

    const payload = {
      propertyId,
      experienceId,
      status,
      err,
      experienceMediaItems: resp.data.reduce((a, v) => ({ ...a, [v.mediaItemId]: v }), {}),
    };

    dispatch({
      type: types.GET_EXPERIENCE_MEDIA_ITEMS,
      payload,
    });
  };
};
